// src/components/ShareFiltersBar.jsx
import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import { IoSearchOutline } from "react-icons/io5";

export default function ShareFiltersBar({
  /* state */
  filters,
  sharedWithInput,
  sharedWithSuggestions = [],

  /* callbacks */
  onContentTypeChange,
  onSearchTextChange,
  onSharedWithInputChange,
  onAddSharedWith,
  onRemoveSharedWith,

  /* data */
  contentTypes = [],
}) {
  return (
    <div className="space-y-3">

      {/* Row 1: Controls */}
      <div className="flex flex-wrap gap-2 items-center">

        {/* Content type dropdown */}
        <select
          value={filters.contentType || ""}
          onChange={(e) => onContentTypeChange(e.target.value)}
          className="px-3 py-2 rounded-md bg-gray-700 border border-gray-600 text-sm text-white"
        >
          <option value="">All content types</option>
          {contentTypes.map((ct) => (
            <option key={ct.value} value={ct.value}>
              {ct.label}
            </option>
          ))}
        </select>

        {/* Search by title / name */}
        <div className="relative flex-1 min-w-[220px]">
          <IoSearchOutline className="absolute left-3 top-2.5 text-gray-400" />
          <input
            value={filters.searchText || ""}
            onChange={(e) => onSearchTextChange(e.target.value)}
            placeholder="Search by name, title or ID"
            className="w-full pl-9 pr-3 py-2 rounded-md bg-gray-700 border border-gray-600 text-sm text-white placeholder-gray-400"
          />
        </div>

        {/* Shared with autocomplete */}
        <div className="relative min-w-[220px]">
          <input
            value={sharedWithInput}
            onChange={(e) => onSharedWithInputChange(e.target.value)}
            placeholder="Shared with…"
            className="w-full px-3 py-2 rounded-md bg-gray-700 border border-gray-600 text-sm text-white placeholder-gray-400"
          />

          {/* Suggestions */}
          {sharedWithSuggestions.length > 0 && (
            <div className="absolute z-10 mt-1 w-full bg-gray-800 border border-gray-600 rounded-md shadow-lg max-h-48 overflow-auto">
              {sharedWithSuggestions.map((s) => (
                <button
                  key={s.id}
                  onClick={() => onAddSharedWith(s)}
                  className="w-full text-left px-3 py-2 text-sm hover:bg-gray-700"
                >
                  <div className="font-medium">{s.label}</div>
                  <div className="text-xs text-gray-400">
                    {s.type === "sp" ? "Service Provider" : "Beneficiary"}
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Row 2: Active filter pills */}
      {filters.sharedWith?.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {filters.sharedWith.map((pill) => (
            <span
              key={pill.id}
              className="flex items-center gap-1 px-3 py-1 rounded-full bg-blue-600 text-xs text-white"
            >
              {pill.label}
              <button
                onClick={() => onRemoveSharedWith(pill.id)}
                className="hover:text-gray-200"
              >
                <AiOutlineClose size={12} />
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
